module.exports = __webpack_public_path__ + "media/images/dmc/tour-02-fba92ebb3bd7980d81f0d82f0d377f34.jpg";